export function changeLanguage(lang) {
  return { type: "CHANGE_LANGUAGE", data: lang };
}
